module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_17.e05ce48e.jpg";